// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import flag01Icon from "@/assets/icons/flag-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Flag01IconProps = Omit<IconProps, "name">;

export function Flag01Icon(props: Flag01IconProps): React.ReactNode {
  return <Icon name={flag01Icon} {...props} />;
}
